// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: Arial, sans-serif;
}

.title h3{
  background-color: #6699cc;
  color: #ffffff;
  padding: 10px;
  text-align: left;
}

.center-content {
  margin: auto !important;
  text-align: center;
}

.mat-elevation-z8 {
  box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
}

.mat-paginator {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}

.button-container {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 20px;
}

th,
td {
  border: 1px solid white;
  text-align: center;
  padding: 8px;
}

th {
  background-color: #0b2d71 !important;
  color: white !important;
  font-weight: bold;
}

td a {
  color: blue;
  text-decoration: none;
}

td a:hover {
  text-decoration: underline;
}
/* .custom-width {
  width: 50%; 
} */
.actions-width{
  width: 13%;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/administrator/doa-sub-categories/doa-sub-categories.component.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,2HAA2H;AAC7H;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;;EAEE,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;AACA;;GAEG;AACH;EACE,UAAU;AACZ","sourcesContent":["body {\n  font-family: Arial, sans-serif;\n}\n\n.title h3{\n  background-color: #6699cc;\n  color: #ffffff;\n  padding: 10px;\n  text-align: left;\n}\n\n.center-content {\n  margin: auto !important;\n  text-align: center;\n}\n\n.mat-elevation-z8 {\n  box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);\n}\n\n.mat-paginator {\n  margin-top: 20px;\n  display: flex;\n  justify-content: center;\n}\n\n.button-container {\n  display: flex;\n  justify-content: center;\n  gap: 20px;\n  margin-top: 20px;\n}\n\nth,\ntd {\n  border: 1px solid white;\n  text-align: center;\n  padding: 8px;\n}\n\nth {\n  background-color: #0b2d71 !important;\n  color: white !important;\n  font-weight: bold;\n}\n\ntd a {\n  color: blue;\n  text-decoration: none;\n}\n\ntd a:hover {\n  text-decoration: underline;\n}\n/* .custom-width {\n  width: 50%; \n} */\n.actions-width{\n  width: 13%;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
